import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoadingBarModule, LoadingBarService } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgLetDirective } from '@libs/shared/utils/directives/ng-let/ng-let.directive';

@Component({
  selector: 'app-loading-bar',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressBarModule,
    LoadingBarHttpClientModule,
    LoadingBarRouterModule,
    LoadingBarModule,
    NgLetDirective,
  ],
  template: `
    <ng-container *ngLet="loader.value$ | async as value">
      @if (value) {
        <mat-progress-bar mode="indeterminate" [value]="value" />
      }
    </ng-container>
    `,
  styles: [
    `
      app-loading-bar {
        position: fixed;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 6px;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainLoadingBarComponent {
  constructor(public loader: LoadingBarService) {}
}
